import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import "./styles/common.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import PremiumToaster from "./components/Common/PremiumToaster";
import { SidebarProvider } from "./hooks/UseSidebar";

// Benign browser warning from MUI/layout animations — suppress dev overlay noise
const resizeObserverErrorPattern =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

window.addEventListener(
  "error",
  (event) => {
    if (resizeObserverErrorPattern.test(event.message)) {
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <SidebarProvider>
      <App />
      <PremiumToaster />
    </SidebarProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
